/* Tower — Pro feature comparison accordion
 *
 * Hydrates #proFeatureList from PRO_FEATURES data. Uses native <details>
 * so the accordion is functional without JS — this script only adds
 * the "single-open" enhancement (opening one closes the others).
 */

var PRO_FEATURES = [
  {
    id: 'stacked-branches',
    name: 'Stacked Branches',
    oneliner: 'Work on dependent features in parallel. Restack your entire branch chain with a single action to keep everything in sync.',
    summary: 'Tower tracks the parent-child relationships Git ignores — and restacks your entire chain in one action.',
    details: [
      'Branch dependencies are tracked automatically: every branch created in Tower remembers which branch it came from.',
      'The "Restack" feature allows you to rebase all branches in the chain up to the trunk with a single click, eliminating the need for manual rebasing of each branch individually.',
      'In the sidebar, child branches are visually nested under their parent, enabling you to view the entire stack at a glance.',
      'Tower shows a restack badge and a yellow banner as soon as a branch lags behind its parent.',
    ],
    learnMore: '/pro/stacked-branches',
  },
  {
    id: 'custom-workflows',
    name: 'Advanced Custom Workflows',
    oneliner: "Start and finish topic branches in a single step. Tower branches off the right base and, when you're done, merges back with your configured strategy and tidies up.",
    summary: 'Tower Pro adds "Start" and "Finish" actions on top of Custom Workflows, automating the branch creation, checkout, merge, and cleanup steps for you.',
    details: [
      "Custom Workflows itself — configuring workflow types, branch types, parent-child relationships, changing a branch's parent, and behind-parent detection — is available in the Tower Basic plan.",
      'Pro adds a guided "Start" action: creates a new branch that follows your workflow\'s naming convention and checks it out immediately.',
      'Pro adds a guided "Finish" action: merges the topic branch into its parent and deletes the fully merged branch right away.',
    ],
    learnMore: '/pro/advanced-custom-workflows',
  },
  {
    id: 'graphite',
    name: 'Graphite Workflow',
    oneliner: 'The full Graphite stacking flow inside Tower — create, restack, and submit linked PRs without touching the CLI.',
    summary: 'Create branches, commit, restack, and submit PRs in Graphite without ever leaving your favorite Git client.',
    details: [
      'Create branches and commits from the Working Copy view with automatic restacking on commit.',
      'Restack individual branches or the full stack (parents and children) with a single click.',
      'Submit stacked branches as linked pull requests in a single action, updating only those branches that already have open PRs.',
      'Sync the entire stack with a single right-click to pull upstream changes across all branches simultaneously.',
    ],
    learnMore: '/pro/graphite-workflow',
  },
  {
    id: 'automatic-branch-management',
    name: 'Automatic Branch Management',
    oneliner: 'Clean up stale and fully-merged branches in bulk. Keep your sidebar tidy without picking through it manually.',
    summary: 'Tower Pro adds a dedicated "Archive Branches" dialog, so that you can sweep dozens of stale or fully-merged branches in one action.',
    details: [
      'The "Archive Branches" dialog lists every merged and stale candidate in one place — review, select, and archive the whole batch in a single action.',
      'Archived branches move to a dedicated sidebar section: still fully functional, never deleted, restorable with a right-click.',
      'Enable automatic archiving to keep your branch list tidy with zero manual effort.',
      'Protect any branch from cleanup with the "Skip Auto-Archiving" flag (pinned branches and Workflow base branches are always exempt).',
    ],
    learnMore: '/pro/automatic-branch-management',
  },
  {
    id: 'self-hosted',
    name: 'Self-Hosted Services',
    oneliner: 'Connect to GitHub Enterprise, Bitbucket Server, GitLab EE/CE, and Azure DevOps Server. PRs, repos, and CI from your on-prem hosts.',
    summary: 'Complete repository management for self-hosted editions of GitHub Enterprise, Bitbucket Server, GitLab EE/CE, and Azure DevOps Server.',
    details: [
      'Supported platforms: GitHub Enterprise, Bitbucket Server, GitLab EE/CE, and Azure DevOps Server.',
      'Point-and-click auth to on-premise instances with custom certs, proxies, and SSO.',
      'Browse repositories, open PRs, review CI status, and file issues against internal hosts.',
      'Per-host credential vault — switch between production, staging, and personal accounts cleanly.',
      'No data leaves your machine: Tower talks directly to your server, never through a relay.',
    ],
    learnMore: '/pro/enterprise-services',
  },
  {
    id: 'pr-merged-detection',
    name: 'PR-Based Merge Detection',
    oneliner: "Detects branches merged via squash or rebase by checking your service's closed PRs — beyond what local Git can see. Clean them up with a single click.",
    summary: "Tower matches your local branches against merged pull requests from your hosting service — reliably catching squash and rebase merges that Git's own history can't detect.",
    details: [
      'Runs four independent checks: Git\'s own merge detection, merged pull requests, merge-commit analysis, and deleted remote-tracking branches.',
      'Supports GitHub, GitLab, Bitbucket, and Azure DevOps, including self-hosted editions.',
      'The "Fully Merged" hint shows exactly which checks matched, with direct links to the merge commit or pull request to verify before deleting.',
      'Pairs with Automatic Branch Management to archive squash- and rebase-merged branches in bulk.',
    ],
    learnMore: '/pro/pr-merged-detection',
  },
  {
    id: 'local-code-review',
    name: 'Local Code Review',
    oneliner: 'Review your changes with AI suggestions side by side before pushing. Catch issues locally, not in PR review.',
    comingSoon: true,
  },
  {
    id: 'sync-branches',
    name: 'Sync Branches',
    oneliner: 'Update multiple branches against their parents in a single batch — no need for individual fetch/pull/rebase operations.',
    comingSoon: true,
  },
];

function renderProFeatures(list, template, data) {
  var frag = document.createDocumentFragment();

  for (var i = 0; i < data.length; i++) {
    var f = data[i];
    var node = template.content.firstElementChild.cloneNode(true);
    node.dataset.id = f.id;

    if (f.comingSoon) {
      node.classList.add('feature--soon');
      node.querySelector('[data-field="name"]').textContent = f.name;
      node.querySelector('[data-field="oneliner"]').textContent = f.oneliner;
      var toggle = node.querySelector('.feature__toggle');
      toggle.innerHTML = '<span class="feature__soonPill">Coming Soon</span>';
    } else {
      node.querySelector('[data-field="name"]').textContent = f.name;
      node.querySelector('[data-field="oneliner"]').textContent = f.oneliner;
      node.querySelector('[data-field="summary"]').textContent = f.summary;

      var learn = node.querySelector('[data-field="learnMoreHref"]');
      learn.href = f.learnMore;

      var points = node.querySelector('[data-field="details"]');
      for (var j = 0; j < f.details.length; j++) {
        var li = document.createElement('li');
        li.textContent = f.details[j];
        points.appendChild(li);
      }
    }

    frag.appendChild(node);
  }

  list.replaceChildren(frag);

  var first = list.querySelector('details:not(.feature--soon details)');
  if (first) first.open = true;
}

function slideOpen(details) {
  details.open = true;
}

function slideClose(details) {
  details.open = false;
}

function wireSingleOpen(list) {
  list.addEventListener('click', function(event) {
    var summary = event.target.closest('summary');
    if (!summary) return;
    var details = summary.closest('details');
    if (!details) return;

    // Don't expand coming-soon rows
    if (summary.closest('.feature--soon')) {
      event.preventDefault();
      return;
    }

    event.preventDefault();
    if (details.open) { slideClose(details); return; }

    var current = list.querySelector('details[open]');
    if (current) slideClose(current);
    slideOpen(details);
  });
}

document.addEventListener('DOMContentLoaded', function() {
  var list = document.getElementById('proFeatureList');
  var tpl  = document.getElementById('proFeatureTemplate');
  if (!list || !tpl) return;
  renderProFeatures(list, tpl, PRO_FEATURES);
  wireSingleOpen(list);
});
